var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInsightsMenuIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 11.5,
  height: 11.5,
  rx: 0.75,
  stroke: "currentColor",
  strokeWidth: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 2,
  width: 8,
  height: 0.666667,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 4,
  width: 6,
  height: 0.666667,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 5.33398,
  width: 5.33333,
  height: 0.666667,
  fill: "currentColor"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 6.66602,
  width: 6,
  height: 0.666667,
  fill: "currentColor"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 9.3335,
  y: 4,
  width: 0.666667,
  height: 0.666667,
  fill: "currentColor"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 9.3335,
  y: 5.33398,
  width: 0.666667,
  height: 0.666667,
  fill: "currentColor"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 9.3335,
  y: 6.66602,
  width: 0.666667,
  height: 0.666667,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 10L3.71429 8.5L4.85714 9.5L6 8.5L7.71429 9.5L10 8",
  stroke: "currentColor",
  strokeWidth: 0.5
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInsightsMenuIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/insights-menu-icon.16a27f7b.svg";
export { ForwardRef as ReactComponent };